<div class="container-fluid">
  <!-- Initial Selection Form -->
  <div *ngIf="!showOrderForm; else formView">
    <div class="row justify-content-center mt-5">
      <div class="col-lg-7">
        <div class="card">
          <div class="card-body">
            <form [formGroup]="orderForm">
              <div class="mb-3">
                <label for="clientName">Client</label>
                <select formControlName="clientName" class="form-control minimal">
                  <option value="" disabled>Select Client</option>
                  <option *ngFor="let client of clientList" [value]="client._id">{{ client.clientName }}</option>
                </select>
              </div>
              <div class="mb-3">
                <label for="orderOption">Option</label>
                <select formControlName="orderOption" class="form-control minimal">
                  <option value="" disabled>Select Option</option>
                  <option value="newJob">New Job</option>
                  <option value="existingJob">Repeated Job</option>
                </select>
              </div>
              <div class="text-end">
                <button type="button" class="btn btn-danger" (click)="handleNext()" [disabled]="!orderForm.valid">
                  Next
                </button>
              </div>

              <!-- <div class="text-end">
                <button type="button" class="btn btn-danger" (click)="NewJob()" [disabled]="!orderForm.valid">
                  Next
                </button>
                <button type="button" class="btn btn-secondary ms-2" (click)="ExtJob()" [disabled]="!orderForm.valid">
                  Existing Job
                </button>
              </div> -->
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- New Job Form -->
  <ng-template #formView>
    <div *ngIf="orderForm.get('orderOption').value === 'newJob'; else existingJobForm">
      <div class="row justify-content-center mt-5">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <form [formGroup]="addOrderForm" (ngSubmit)="addOrder()">
                <div class="row">
                  <div class="col-md-4 mb-3"> <label class="form-label">Client Name</label> <input type="text"
                      class="form-control" formControlName="clientName" [value]="selectedClient?.clientName" readonly
                      disabled>
                    <div
                      *ngIf="addOrderForm.get('clientName')?.invalid && (addOrderForm.get('clientName')?.dirty || addOrderForm.get('clientName')?.touched)"
                      class="text-danger">
                      <div *ngIf="addOrderForm.get('clientName')?.errors?.required">Client Name is required.</div>
                    </div>
                  </div>
                  <div class="col-md-4 mb-3"> <label for="ticketno" class="form-label">Ticket No</label> <input
                      type="text" formControlName="ticketno" id="ticketno" class="form-control" readonly disabled />
                    <div
                      *ngIf="addOrderForm.get('ticketno')?.invalid && (addOrderForm.get('ticketno')?.dirty || addOrderForm.get('ticketno')?.touched)"
                      class="text-danger">
                      <div *ngIf="addOrderForm.get('ticketno')?.errors?.required">Ticket No is required.</div>
                    </div>
                  </div>
                  <div class="col-md-4 mb-3"> <label for="ddDate" class="form-label">Delivey Date</label>
                    <input type="date" formControlName="ddDate" id="ddDate" class="form-control" />
                    <div
                      *ngIf="addOrderForm.get('ddDate')?.invalid && (addOrderForm.get('ddDate')?.dirty || addOrderForm.get('ddDate')?.touched)"
                      class="text-danger">
                      <div *ngIf="addOrderForm.get('ddDate')?.errors?.required">Delivery Date is required.</div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 mb-3"> <label for="jobName" class="form-label">Job Name</label> <input
                      type="text" formControlName="jobName" id="jobName" class="form-control"
                      placeholder="Enter Job Name" />
                    <div
                      *ngIf="addOrderForm.get('jobName')?.invalid && (addOrderForm.get('jobName')?.dirty || addOrderForm.get('jobName')?.touched)"
                      class="text-danger">
                      <div *ngIf="addOrderForm.get('jobName')?.errors?.required">Job Name is required.</div>
                    </div>
                  </div>
                  <div class="col-md-4 mb-3"> <label for="jobType" class="form-label">Job Type</label>
                    <div class="input-group input-group2">
                      <select formControlName="jobType" id="jobType" class="form-control minimal">
                        <option value="" disabled>Select Job Type</option>
                        <option value="Roll Form">Roll Form</option>
                        <option value="Kgs/Pcs">Kgs/Pcs</option>
                        <!-- <option value="Sleeves">Sleeves</option>
                      <option value="Labels">Labels</option> -->
                      </select>
                      <div
                        *ngIf="addOrderForm.get('jobType')?.invalid && (addOrderForm.get('jobType')?.dirty || addOrderForm.get('jobType')?.touched)"
                        class="text-danger">
                        <div *ngIf="addOrderForm.get('jobType')?.errors?.required">Job Type is required.</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 mb-3"> <label for="refNo" class="form-label">Ref No</label> <input type="text"
                      formControlName="refNo" id="refNo" class="form-control" placeholder="Enter Ref No" />
                    <div
                      *ngIf="addOrderForm.get('refNo')?.invalid && (addOrderForm.get('refNo')?.dirty || addOrderForm.get('refNo')?.touched)"
                      class="text-danger">
                      <div *ngIf="addOrderForm.get('refNo')?.errors?.required">Ref No is required.</div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-3"> <label for="sMat" class="form-label">Standard Material Structure</label>
                    <div class="input-group input-group2">
                      <select formControlName="sMat" id="sMat" class="form-control minimal">
                        <option value="" disabled>Select Standard Material Structure</option>
                        <option value="CLEAR BOPP">CLEAR BOPP</option>
                        <option value="MET BOPP">MET BOPP</option>
                        <option value="PEARL BOPP">PEARL BOPP</option>
                        <option value="MATT BOPP">MATT BOPP</option>
                        <option value="CLEAR PET">CLEAR PET</option>
                        <option value="CT PET">CT PET</option>
                        <option value="CLEAR PP">CLEAR PP</option>

                        <option value="CC PET">CC PET</option>
                        <option value="CT+CC PET">CT+CC PET</option>
                        <option value="SHRINK PET (PETG)">SHRINK PET (PETG)</option>
                        <option value="MET PET">MET PET</option>
                        <option value="MATT PET">MATT PET</option>
                        <option value="PVC TWIST CLEAR">PVC TWIST CLEAR</option>
                        <option value="PVC SHRINK">PVC SHRINK</option>
                        <option value="PVC TWIST ORANGE">PVC TWIST ORANGE</option>
                        <option value="CPP MET">CPP MET</option>
                        <option value="CPP CLEAR">CPP CLEAR</option>
                        <option value="LDPE -SHRINK">LDPE -SHRINK</option>
                        <option value="LDPE LAMINATION">LDPE LAMINATION</option>
                        <option value="LDPE CLEAR">LDPE CLEAR</option>
                        <option value="LDPE WHITE">LDPE WHITE</option>
                        <option value="FOIL ALU">FOIL ALU</option>
                        <option value="HDPE CLEAR">HDPE CLEAR</option>
                        <option value="WIP">WIP</option>
                      </select>
                      <div
                        *ngIf="addOrderForm.get('sMat')?.invalid && (addOrderForm.get('sMat')?.dirty || addOrderForm.get('sMat')?.touched)"
                        class="text-danger">
                        <div *ngIf="addOrderForm.get('sMat')?.errors?.required">Standard Material Structure is required.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3 d-flex ">
                    <div class="col-md-6 mb-3"> <label for="thickness" class="form-label">Material Thickness (µ)</label>
                      <input type="text" formControlName="thickness" id="thickness" class="form-control"
                        placeholder="Enter Thickness (in µ)" />
                      <div
                        *ngIf="addOrderForm.get('thickness')?.invalid && (addOrderForm.get('thickness')?.dirty || addOrderForm.get('thickness')?.touched)"
                        class="text-danger">
                        <div *ngIf="addOrderForm.get('thickness')?.errors?.required">Thickness is required.</div>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3 ms-2"> <label for="width" class="form-label">Material Width (mm)</label>
                      <input type="text" formControlName="width" id="width" class="form-control"
                        placeholder="Enter Width (mm)" />
                      <div
                        *ngIf="addOrderForm.get('width')?.invalid && (addOrderForm.get('width')?.dirty || addOrderForm.get('width')?.touched)"
                        class="text-danger">
                        <div *ngIf="addOrderForm.get('width')?.errors?.required">Width is required.</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group mb-3" [formGroup]="addOrderForm.get('material1')">
                  <div class="row d-flex">
                      <div class="col form-group mb-3">
                  <label for="sMat2" class="form-label">Standard Material Structure (Optional)</label>
                  <select formControlName="sMat2" id="sMat2" class="form-control minimal">
                    <option value="" disabled>Select Standard Material Structure</option>
                    <option value="CLEAR BOPP">CLEAR BOPP</option>
                    <option value="MET BOPP">MET BOPP</option>
                    <option value="PEARL BOPP">PEARL BOPP</option>
                    <option value="MATT BOPP">MATT BOPP</option>
                    <option value="CLEAR PET">CLEAR PET</option>
                    <option value="CT PET">CT PET</option>
                    <option value="CLEAR PP">CLEAR PP</option>

                    <option value="CC PET">CC PET</option>
                    <option value="CT+CC PET">CT+CC PET</option>
                    <option value="SHRINK PET (PETG)">SHRINK PET (PETG)</option>
                    <option value="MET PET">MET PET</option>
                    <option value="MATT PET">MATT PET</option>
                    <option value="PVC TWIST CLEAR">PVC TWIST CLEAR</option>
                    <option value="PVC SHRINK">PVC SHRINK</option>
                    <option value="PVC TWIST ORANGE">PVC TWIST ORANGE</option>
                    <option value="CPP MET">CPP MET</option>
                    <option value="CPP CLEAR">CPP CLEAR</option>
                    <option value="LDPE -SHRINK">LDPE -SHRINK</option>
                    <option value="LDPE LAMINATION">LDPE LAMINATION</option>
                    <option value="LDPE CLEAR">LDPE CLEAR</option>
                    <option value="LDPE WHITE">LDPE WHITE</option>
                    <option value="FOIL ALU">FOIL ALU</option>
                    <option value="HDPE CLEAR">HDPE CLEAR</option>
                    <option value="WIP">WIP</option>
                  </select>
                  <button *ngIf="addOrderForm.get('material1.sMat2').value" type="button" class="btn btn-secondary mt-2" (click)=" resetmaterial1()">Reset</button>
                  </div>
                
                  <div class="col form-group mb-3">
                    <label class="form-label">Material Thickness (µ)(Optional)</label>
                    <input type="text"
                           [formControl]="addOrderForm.get('material1.thickness2')"
                           id="thickness2" 
                           class="form-control" 
                           placeholder="0" />
                  </div>
                    <div class="col form-group mb-3">
                      <label class="form-label">Material Width (mm)(Optional)</label>
                      <input type="text"
                             [formControl]="addOrderForm.get('material1.width2')"
                             id="width2" 
                             class="form-control" 
                             placeholder="0" />
                    </div>
                    
                 
                </div>
                </div>
                
                <div class="form-group mb-3" [formGroup]="addOrderForm.get('material2')">
                  <div class="row d-flex">
                      <div class="col form-group mb-3">
                  <label for="sMat3" class="form-label">Standard Material Structure (Optional)</label>
                  <select formControlName="sMat3" id="sMat3" class="form-control minimal">
                    <option value="" disabled>Select Standard Material Structure</option>
                    <option value="CLEAR BOPP">CLEAR BOPP</option>
                    <option value="MET BOPP">MET BOPP</option>
                    <option value="PEARL BOPP">PEARL BOPP</option>
                    <option value="MATT BOPP">MATT BOPP</option>
                    <option value="CLEAR PET">CLEAR PET</option>
                    <option value="CT PET">CT PET</option>
                    <option value="CLEAR PP">CLEAR PP</option>
                    <option value="CC PET">CC PET</option>
                    <option value="CT+CC PET">CT+CC PET</option>
                    <option value="SHRINK PET (PETG)">SHRINK PET (PETG)</option>
                    <option value="MET PET">MET PET</option>
                    <option value="MATT PET">MATT PET</option>
                    <option value="PVC TWIST CLEAR">PVC TWIST CLEAR</option>
                    <option value="PVC SHRINK">PVC SHRINK</option>
                    <option value="PVC TWIST ORANGE">PVC TWIST ORANGE</option>
                    <option value="CPP MET">CPP MET</option>
                    <option value="CPP CLEAR">CPP CLEAR</option>
                    <option value="LDPE -SHRINK">LDPE -SHRINK</option>
                    <option value="LDPE LAMINATION">LDPE LAMINATION</option>
                    <option value="LDPE CLEAR">LDPE CLEAR</option>
                    <option value="LDPE WHITE">LDPE WHITE</option>
                    <option value="FOIL ALU">FOIL ALU</option>
                    <option value="HDPE CLEAR">HDPE CLEAR</option>
                    <option value="WIP">WIP</option>
                  </select>
                  <button *ngIf="addOrderForm.get('material2.sMat3').value" type="button" class="btn btn-secondary mt-2" (click)=" resetmaterial2()">Reset</button>
                  </div>
                
                  <div class="col form-group mb-3">
                    <label class="form-label">Material Thickness (µ)(Optional)</label>
                    <input type="text"
                           [formControl]="addOrderForm.get('material2.thickness3')"
                           id="thickness3" 
                           class="form-control" 
                           placeholder="0" />
                  </div>
                    <div class="col form-group mb-3">
                      <label class="form-label">Material Width(mm)(Optional)</label>
                      <input type="text"
                             [formControl]="addOrderForm.get('material2.width3')"
                             id="width3" 
                             class="form-control" 
                             placeholder="0" />
                    </div>
                 
                 
                </div>
                </div>
              
                
                <div class="row">
                  <div class="col-md-3 mb-3"> <label for="poDate" class="form-label">PO Received Date</label>
                    <input type="date" formControlName="poDate" id="poDate" class="form-control" />
                    <div
                      *ngIf="addOrderForm.get('poDate')?.invalid && (addOrderForm.get('poDate')?.dirty || addOrderForm.get('poDate')?.touched)"
                      class="text-danger">
                      <div *ngIf="addOrderForm.get('poDate')?.errors?.required">PO Received Date is required.</div>
                    </div>
                  </div>
                  <div class="col-md-3 mb-3"> <label for="poNo" class="form-label">PO No</label> <input type="text"
                      formControlName="poNo" id="poNo" class="form-control" placeholder="Enter PO No" />
                    <div
                      *ngIf="addOrderForm.get('poNo')?.invalid && (addOrderForm.get('poNo')?.dirty || addOrderForm.get('poNo')?.touched)"
                      class="text-danger">
                      <div *ngIf="addOrderForm.get('poNo')?.errors?.required">PO No is required.</div>
                    </div>
                  </div>
                  <div class="col-md-3 mb-3"> <label for="coilod" class="form-label">Coil OD</label> <input type="text"
                      formControlName="coilod" id="coilod" class="form-control" placeholder="Enter Coil OD" />

                    <div
                      *ngIf="addOrderForm.get('coilod')?.invalid && (addOrderForm.get('coilod')?.dirty || addOrderForm.get('coilod')?.touched)"
                      class="text-danger">
                      <div *ngIf="addOrderForm.get('coilod')?.errors?.required">Coil OD is required.</div>
                    </div>
                  </div>
                  <div class="col-md-3 mb-3"> <label for="coilWidth" class="form-label">Coil Width</label> <input
                      type="text" formControlName="coilWidth" id="coilWidth" class="form-control"
                      placeholder="Enter Coil Width" />
                    <div
                      *ngIf="addOrderForm.get('coilWidth')?.invalid && (addOrderForm.get('coilWidth')?.dirty || addOrderForm.get('coilWidth')?.touched)"
                      class="text-danger">
                      <div *ngIf="addOrderForm.get('coilWidth')?.errors?.required">Coil Width is required.</div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-3"> <label for="sRemrk" class="form-label">Shade Remark</label> <input
                      type="text" formControlName="sRemrk" id="sRemrk" class="form-control"
                      placeholder="Enter Shade Remark" />
                    <div
                      *ngIf="addOrderForm.get('sRemrk')?.invalid && (addOrderForm.get('sRemrk')?.dirty || addOrderForm.get('sRemrk')?.touched)"
                      class="text-danger">
                      <div *ngIf="addOrderForm.get('sRemrk')?.errors?.required">Shade Remark is required.</div>
                    </div>
                  </div>
                  <div class="col-md-3 mb-3"> <label for="barcode" class="form-label">Barcode Number</label> <input
                      type="text" formControlName="barcode" id="barcode" class="form-control"
                      placeholder="Enter Barcode Number" />
                    <div
                      *ngIf="addOrderForm.get('barcode')?.invalid && (addOrderForm.get('barcode')?.dirty || addOrderForm.get('barcode')?.touched)"
                      class="text-danger">
                      <div *ngIf="addOrderForm.get('barcode')?.errors?.required">Barcode Number is required.</div>
                    </div>
                  </div>
                  <div class="col-md-3 mb-3"> <label for="dispatch" class="form-label">Dispatch Type</label> <input
                      type="text" formControlName="dispatch" id="dispatch" class="form-control"
                      placeholder="Enter Dispatch Type" />
                    <div
                      *ngIf="addOrderForm.get('dispatch')?.invalid && (addOrderForm.get('dispatch')?.dirty || addOrderForm.get('dispatch')?.touched)"
                      class="text-danger">
                      <div *ngIf="addOrderForm.get('dispatch')?.errors?.required">Dispatch Type is required.</div>
                    </div>
                  </div>
                  <div class="col-md-3 mb-3"> <label for="remark" class="form-label">Remark</label> <input type="text"
                      formControlName="remark" id="remark" class="form-control" placeholder="Enter Remark" />
                    <div
                      *ngIf="addOrderForm.get('remark')?.invalid && (addOrderForm.get('remark')?.dirty || addOrderForm.get('remark')?.touched)"
                      class="text-danger">
                      <div *ngIf="addOrderForm.get('remark')?.errors?.required">Remark is required.</div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 mb-3">
                    <label for="orderPcs" class="form-label ml-3">Order Pcs</label>
                    <input type="text" formControlName="orderPcs" id="orderPcs" class="form-control ml-2"
                      placeholder="Enter Pcs to calculate" />
                    <button type="button" class="btn btn-outline-success btn-sm ml-3" (click)="togglePcsGram()"
                      title="Calculate">
                      <i class="feather ticket "></i>Calculate
                    </button>
                    <div
                      *ngIf="addOrderForm.get('orderPcs')?.invalid && (addOrderForm.get('orderPcs')?.dirty || addOrderForm.get('orderPcs')?.touched)"
                      class="text-danger">
                      <div *ngIf="addOrderForm.get('orderPcs')?.errors?.required">Order Pcs is required.</div>
                    </div>
                  </div>

                  <!-- Hidden by default, shown after clicking "Calculate" -->
                  <div class="col-md-4 mb-3" *ngIf="showPcsGram">
                    <!-- <span>Total order in pcs={{totalPcs}}</span> -->
                    <!-- <span>Total Order Pcs/Kg</span> -->
                    <!-- <label for="gram" class="form-label">Pcs/gram =</label> -->
                    <label for="gram" clas="form-label">Total Order Pcs/Kg</label>
                    <input type="text" formControlName="gram" id="gram" class="form-control" />
                    <button type="button" class="btn btn-outline-success btn-sm ml-3" title="Calculate"
                      (click)="calculateOrderKgs()">
                      <i class="feather ticket "></i>Cal kg
                    </button>
                    <div
                      *ngIf="addOrderForm.get('gram')?.invalid && (addOrderForm.get('gram')?.dirty || addOrderForm.get('gram')?.touched)"
                      class="text-danger">
                      <div *ngIf="addOrderForm.get('gram')?.errors?.required">Gram is required.</div>
                    </div>
                  </div>


                  <div class="col-md-4 mb-3">
                    <label for="orderKgs" class="form-label">|| Order Kgs</label>
                    <input type="text" formControlName="orderKgs" id="orderKgs" class="form-control"
                      placeholder="Enter quantity in Kg" />
                    <div
                      *ngIf="addOrderForm.get('orderKgs')?.invalid && (addOrderForm.get('orderKgs')?.dirty || addOrderForm.get('orderKgs')?.touched)"
                      class="text-danger">
                      <div *ngIf="addOrderForm.get('orderKgs')?.errors?.required">Order Kgs is required.</div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-3"> <label for="fdOption" class="form-label">Final Direction Option</label>
                    <div class="input-group input-group2"> <select formControlName="fdOption" id="fdOption"
                        class="form-control custom-select minimal">
                        <option value="" disabled>Select Final Direction</option>
                        <option value="EMRS">EMRS</option>
                        <option value="EMLS">EMLS</option>
                        <option value="Readable">Readable</option>
                        <option value="Non-Readable">Non-Readable</option>
                        <option value="Any Direction">Any Direction</option>
                        <option value="Direction not Required">Direction not Required</option>
                      </select>
                      <div
                        *ngIf="addOrderForm.get('fdOption')?.invalid && (addOrderForm.get('fdOption')?.dirty || addOrderForm.get('fdOption')?.touched)"
                        class="text-danger">
                        <div *ngIf="addOrderForm.get('fdOption')?.errors?.required">Final Direction Option is required.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 mb-3"> <label for="packageType" class="form-label">Packaging Type</label>
                    <div class="input-group input-group2"> <select formControlName="packageType" id="packageType"
                        class="form-control custom-select minimal">
                        <option value="" disabled>Select Packaging Type</option>
                        <option value="Pallets">Pallets</option>
                        <option value="Bundles">Bundles</option>
                        <option value="Box">Box</option>
                        <option value="Others">Others</option>
                      </select>
                      <div
                        *ngIf="addOrderForm.get('packageType')?.invalid && (addOrderForm.get('packageType')?.dirty || addOrderForm.get('packageType')?.touched)"
                        class="text-danger">
                        <div *ngIf="addOrderForm.get('packageType')?.errors?.required">Packaging Type is required.</div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-md-6 mb-3 d-flex "> -->
                  <div class="col-md-3 mb-3"> <label for="prepare" class="form-label">Prepared By</label> <input
                      type="text" formControlName="prepare" id="prepare" class="form-control"
                      placeholder="Prepared By" />
                    <div
                      *ngIf="addOrderForm.get('prepare')?.invalid && (addOrderForm.get('prepare')?.dirty || addOrderForm.get('prepare')?.touched)"
                      class="text-danger">
                      <div *ngIf="addOrderForm.get('prepare')?.errors?.required">Prepared By is required.</div>
                    </div>
                  </div>
                  <div class="col-md-3 mb-3"> <label for="approved" class="form-label">Approved By</label> <input
                      type="text" formControlName="approved" id="approved" class="form-control"
                      placeholder="Approved By" />
                    <div
                      *ngIf="addOrderForm.get('approved')?.invalid && (addOrderForm.get('approved')?.dirty || addOrderForm.get('approved')?.touched)"
                      class="text-danger">
                      <div *ngIf="addOrderForm.get('approved')?.errors?.required">Approved By is required.</div>
                    </div>
                  </div>
                  <!-- </div> -->
                </div>
                <!-- <div class="text-end">
                  <button type="submit" class="btn btn-primary" [disabled]="!addOrderForm.valid">
                    <button type="submit" class="btn btn-primary" [disabled]="!addOrderForm.valid || isSubmitting">
                    Add Order</button>
                </div> -->
                <div class="text-end">
  <button type="submit" class="btn btn-primary" [disabled]="!addOrderForm.valid || isSubmitting">
    <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    <span *ngIf="!isSubmitting">Add Order</span>
    <span *ngIf="isSubmitting" class="ml-2">Submitting...</span>
  </button>
</div>
              </form>



            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Existing Job Form -->
  <ng-template #existingJobForm>
    <div class="row justify-content-center mt-5" *ngIf="showExeForm">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form [formGroup]="existingJob">
              <div class="row">
                <div class="col-md-4 mb-3">
                  <label for="clientName" class="form-label">Client Name</label>
                  <input type="text" formControlName="clientName" id="clientName" class="form-control" readonly
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <label for="ticketno" class="form-label">Client Ticket</label>
                  <input type="text" formControlName="ticketno" id="ticketno" class="form-control" readonly  />
                </div>
                <!-- <div class="col-md-4 mb-3">
                  <label for="jobName" class="form-label">Job Name</label>
                  <input type="text" formControlName="jobName" id="jobName" class="form-control" disabled />
                </div> -->
                <!-- job-selector.component.html -->
                <!-- <div class="col-md-4 mb-3">
                  <label for="refNo" class="form-label">Job Ref No</label>
                  <select formControlName="refNo" id="refNo" class="form-control"
                    (change)="onrefNoChange($event.target.value)">
                    <option value="" disabled>Select Ref No</option>

                    <option *ngFor="let job of jsIdList" [value]="job">{{ job }}</option>
                  </select>
                  <div
                    *ngIf="existingJob.get('refNo')?.invalid && (existingJob.get('refNo')?.dirty || existingJob.get('refNo')?.touched)"
                    class="text-danger">
                    <div *ngIf="existingJob.get('refNo')?.errors?.required">Job Name is required.</div>
                  </div>
                </div> -->
                <div class="col-md-4 mb-3">
  <label for="refNo" class="form-label">Job Ref No</label>

  <ng-select
    [items]="jsIdList"
    bindLabel="refNo"
    [searchable]="true"
    [clearable]="true"
    formControlName="refNo"
    placeholder="Select Ref No"
    (change)="onrefNoChange($event)">
  </ng-select>

  <div
    *ngIf="existingJob.get('refNo')?.invalid && (existingJob.get('refNo')?.dirty || existingJob.get('refNo')?.touched)"
    class="text-danger">
    <div *ngIf="existingJob.get('refNo')?.errors?.required">Job Ref No is required.</div>
  </div>
</div>

                <div class="col-md-4 mb-3">
                  <label for="jssId" class="form-label">JSS Number</label>
                  <input type="text" formControlName="jssId" id="jssId" class="form-control" readonly />
                </div>
                <div class="col-md-4 mb-3"> <label for="jobName" class="form-label">Job Name</label>
                  <input type="text" formControlName="jobName" id="jobName" class="form-control" />
                  <div
                    *ngIf="existingJob.get('jobName')?.invalid && (existingJob.get('jobName')?.dirty || existingJob.get('jobName')?.touched)"
                    class="text-danger">
                    <div *ngIf="existingJob.get('jobName')?.errors?.required">Job Name is required.</div>
                  </div>
                </div>
                <!-- <div class="col-md-4 mb-3" *ngIf="jsIdList.length > 0">
                  <label for="jssId">Select JSS ID:</label>
                  <select id="jssId" formControlName="jssId" class="form-control" (change)="fetchJssDetails($event.target.value)">
                    <option value="" disabled>Select JSS ID</option>
                    <option *ngFor="let item of jsIdList" [value]="item.id">{{ item.id}}</option>
                  </select>
                </div> -->

                <div class="col-md-4 mb-3">
                  <label for="poNo" class="form-label">PO Number </label>
                  <input type="text" formControlName="poNo" id="poNo" class="form-control" />
                  <div
                    *ngIf="existingJob.get('poNo')?.invalid && (existingJob.get('poNo')?.dirty || existingJob.get('poNo')?.touched)"
                    class="text-danger">
                    <div *ngIf="existingJob.get('poNo')?.errors?.required">PO Number is required.</div>
                  </div>
                </div>
                <div class="col-md-4 mb-3"> <label for="poDate" class="form-label">PO Received Date
                    </label>
                  <input type="date" formControlName="poDate" id="poDate" class="form-control" />
                  <div
                    *ngIf="existingJob.get('poDate')?.invalid && (existingJob.get('poDate')?.dirty || existingJob.get('poDate')?.touched)"
                    class="text-danger">
                    <div *ngIf="existingJob.get('poDate')?.errors?.required">PO Received Date is required.</div>
                  </div>
                </div>

                <div class="col-md-4 mb-3"> <label for="ddDate" class="form-label">Delivery Date </label>
                  <input type="date" formControlName="ddDate" id="ddDate" class="form-control" />
                  <div
                    *ngIf="existingJob.get('ddDate')?.invalid && (existingJob.get('ddDate')?.dirty || existingJob.get('ddDate')?.touched)"
                    class="text-danger">
                    <div *ngIf="existingJob.get('ddDate')?.errors?.required">Delivery Date is required.</div>
                  </div>
                </div>


                <div class="col-md-4 mb-3">
                  <label for="orderPcs" class="form-label ml-3">Order Pcs </label>
                  <input type="text" formControlName="orderPcs" id="orderPcs" class="form-control ml-2"
                    placeholder="Enter Pcs to calculate" />
                  <button type="button" class="btn btn-outline-success btn-sm ml-3" (click)="togglePcsGram()"
                    title="Calculate">
                    <i class="feather ticket"></i>Calculate
                  </button>
                  <div
                    *ngIf="existingJob.get('orderPcs')?.invalid && (existingJob.get('orderPcs')?.dirty || existingJob.get('orderPcs')?.touched)"
                    class="text-danger">
                    <div *ngIf="existingJob.get('orderPcs')?.errors?.required">Order Pcs is required.</div>
                  </div>
                </div>

                <div class="col-md-4 mb-3" *ngIf="showPcsGram">
                  <label for="gram" class="form-label">Total Order Pcs/Kg </label>
                  <input type="text" formControlName="gram" id="gram" class="form-control" />
                  <button type="button" class="btn btn-outline-success btn-sm ml-3" title="Calculate"
                    (click)="calculateOrderKgsExit()">
                    <i class="feather ticket"></i>Cal kg
                  </button>
                  <div
                    *ngIf="existingJob.get('gram')?.invalid && (existingJob.get('gram')?.dirty || existingJob.get('gram')?.touched)"
                    class="text-danger">
                    <div *ngIf="existingJob.get('gram')?.errors?.required">Gram is required.</div>
                  </div>
                </div>

                <div class="col-md-4 mb-3">
                  <label for="orderKgs" class="form-label"> Order Kgs </label>
                  <input type="text" formControlName="orderKgs" id="orderKgs" class="form-control"
                    placeholder="Enter quantity in Kg" />
                  <div
                    *ngIf="existingJob.get('orderKgs')?.invalid && (existingJob.get('orderKgs')?.dirty || existingJob.get('orderKgs')?.touched)"
                    class="text-danger">
                    <div *ngIf="existingJob.get('orderKgs')?.errors?.required">Order Qty is required.</div>
                  </div>
                </div>


                <!-- <div class="col-md-4 mb-3">
                  <label for="orderKgs" class="form-label">Order Qty</label>
                  <input type="text" formControlName="orderKgs" id="orderKgs" class="form-control" />
                  <div
                    *ngIf="existingJob.get('orderKgs')?.invalid && (existingJob.get('orderKgs')?.dirty || existingJob.get('orderKgs')?.touched)"
                    class="text-danger">
                    <div *ngIf="existingJob.get('orderKgs')?.errors?.required">Order Qty is required.</div>
                  </div>
                </div> -->
                <div class="col-md-4 mb-3">
                  <label for="avgWastage" class="form-label">Average Wastage %</label>
                  <input type="text" formControlName="avgWastage" id="avgWastage" class="form-control" readonly />
                  <div
                    *ngIf="existingJob.get('avgWastage')?.invalid && (existingJob.get('avgWastage')?.dirty || existingJob.get('avgWastage')?.touched)"
                    class="text-danger">
                    <div *ngIf="existingJob.get('avgWastage')?.errors?.required">Average Wastage % is required.</div>
                  </div>
                </div>

                <div class="col-md-4 mb-3">
                  <label for="repeatedRemarks" class="form-label">Remarks</label>
                  <input type="text" formControlName="repeatedRemarks" id="repeatedRemarks" class="form-control"  />
                  <!-- <div
                    *ngIf="existingJob.get('avgWastage')?.invalid && (existingJob.get('avgWastage')?.dirty || existingJob.get('avgWastage')?.touched)"
                    class="text-danger">
                    <div *ngIf="existingJob.get('avgWastage')?.errors?.required">Average Wastage % is required.</div>
                  </div> -->
                </div>
              </div>

              <!-- Materials Table and Total Calculations -->
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Process</th>
                      <th>Material</th>
                      <th>Density</th>
                      <th>Avg Wastage{{initialOrderper}} %</th>
                      <th>Thickness</th>
                      <th>GSM</th>
                      <th>Net RM</th>
                      <th>Wastage %</th>
                      <th>Mat_Required</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of combinedMaterials; let i = index">
                      <td>{{ item.process}}</td>
                      <td>{{ item.material || item.extMat}}</td>
                      <td>{{ item.density }}</td>
                      <td>{{ updateOperperValue() | number:'1.2-2' }}</td>
                      <td>{{ item.thickness }}</td>
                      <td>{{ item.gsm }}</td>
                      <td>{{ item.netRm }}</td>
                      <td>
                        <input type="text" formControlName="waste" [(ngModel)]="item.waste" placeholder="Enter Waste"
                          readonly>
                      </td>
                      <td>{{ item.matRequired }}</td>
                      <td>
                        <button type="button" class="btn btn-outline-success btn-sm" (click)="calcMatReq(item)">
                          <i class="feather icon-dollar-sign"></i> Calc
                        </button>
                        <button type="button" class="btn btn-outline-danger btn-sm" (click)="deleteMaterial(i)">
                          <i class="feather icon-trash-2 text-danger"></i>
                        </button>
                      </td>
                    </tr>


                  </tbody>
                </table>
              </div>

              <!-- Total Calculations -->
              <div class="row">
                <div class="col-8"></div>
                <div class="col-4">
                  <table class="table table-sm text-right">
                    <tbody>
                      <tr>
                        <td><strong>Material Grand Total</strong></td>
                        <td class="text-right" *ngIf="grandTotalMatReq">{{ grandTotalMatReq.toFixed(2) }} <span
                            class="currency">Kgs</span></td>
                      </tr>
                      <tr>
                        <td>Wastage in kgs</td>
                        <td class="text-right" *ngIf="wasteInKg">{{ wasteInKg.toFixed(2) }} <span
                            class="currency">Kgs</span></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <hr class="mb-3" />
              <!-- <div class="row">
                <div class="col form-group mb-3 mt-20">
                  <label for="gluing" class="form-label">Gluing Rolls</label>

                  <input type="text" formControlName="gluing" id="gluing" class="form-control" placeholder="0" />
                </div>


                <div class="col form-group">
                  <label for="adhesive" class="form-label form-label-a">Adhesive</label>

                  <div class=" row d-flex">
                    <div class="col form-group">
                      <label class="form-label form-label-a">NCO</label>
                      <input type="text" formControlName="nco" id="nco" class="form-control" placeholder="NCO" />
                    </div>
                    <div class="col form-group ">
                      <label class="form-label form-label-a">OH</label>
                      <input type="text" formControlName="oh" id="oh" class="form-control" placeholder="OH" />
                    </div>
                  </div>


                </div>

                <div class="col form-group mb-3 mt-20">
                  <label for="cutting" class="form-label">Cutting Size</label>
                  <input type="text" formControlName="cutting" id="cutting" class="form-control" />
                </div>
              </div> -->
              <div class="row">
                <div class="col form-group mb-3">
                  <label for="prepared" class="form-label">Prepared by</label>
                  <input type="text" formControlName="prepared" id="prepared" class="form-control" />
                </div>
                <div class="col form-group mb-3">
                  <label for="approved" class="form-label">Approved by</label>
                  <input type="text" formControlName="approved" id="approved" class="form-control" />
                </div>

              </div>
              <!-- <div class="col-auto mt-4">
                <button type="submit" class="btn btn-outline-danger"  [disabled]="existingJob.invalid" (click)="saveAndContinue()">Save</button>
              </div> -->
              <div class="col-auto mt-4">
  <button type="submit" class="btn btn-outline-danger" [disabled]="existingJob.invalid || isSaving" (click)="saveAndContinue()">
    <span *ngIf="isSaving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    <span *ngIf="!isSaving">Save</span>
    <span *ngIf="isSaving" class="ml-2">Saving...</span>
  </button>
</div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

</div>





